// @flow
import autolinker from "autolinker"
import Polyglot from "kiwi-polyglot"
import * as R from "ramda"

import capitalize from "common/utils/capitalize"
import startCase from "common/utils/startCase"
import upperFirst from "common/utils/upperFirst"

type Processors = { [key: string]: (val: string) => string }

type Values = { [key: string]: string }

export type Translations = { [key: string]: string }

type Options = {
  translations?: Translations,
  process?: string | string[],
  language?: string,
  defaultShow?: string,
}

const PROCESSORS: Processors = {
  linify: input => input.replace(/\n/g, "<br />"),
  linkify: input =>
    autolinker.link(input, {
      className: "spTypoLink",
    }),
  addClassToLinks: input => input.replace(/<a /g, '<a class="spTypoLink" target="_blank" '),
  firstCharUp: capitalize,
  uppercase: R.toUpper,
  lowercase: R.toLower,
  startCase,
  capitalizeFirstChar: upperFirst,
}

export default function pureTranslate(
  key: string,
  values: Values = {},
  options: Options = {},
): string {
  // Normalize args
  // ---
  const translations = options.translations || {}

  const fallback = R.is(String, options.defaultShow) ? options.defaultShow : key

  const translated = translations[key] || fallback
  const text = Polyglot.transformPhrase(translated, values, options.language)

  // Process
  // ---
  if (Array.isArray(options.process)) {
    return options.process.reduce((result, funcName) => PROCESSORS[funcName](result), text)
  }

  if (R.is(String, options.process)) {
    // $FlowFixMe - I don't know how to tell Flow that fp.isString works as 'typeof val === "string"'
    return PROCESSORS[options.process](text)
  }

  return text
}
